import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { UserKeys } from '../../../api/users-api';
import { User } from '../../../../types';
import {
  UserRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';

interface OrgUnitsLimitedVizToolbarProps {
  setOpenMoveUserDialog: Dispatch<SetStateAction<boolean>>;
  setUserData: Dispatch<SetStateAction<User[]>>;
  selectedRows: string[];
  userRoles: string[];
}

export default function OrgUnitsLimitedVizToolbar({
  setUserData,
  setOpenMoveUserDialog,
  selectedRows,
  userRoles,
}: OrgUnitsLimitedVizToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      noQuickFilter
      noFilter
      secondaryButtons={
        <>
          <SharedIconButton
            variant="transfer"
            onClick={() => setOpenMoveUserDialog(true)}
            disabled={
              selectedRows.length === 0 ||
              !isAbleToSeeUIElement(
                userRoles,
                UserRoles.BulkSetOrganization.value
              )
            }
            tooltipLabel="Transfer"
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              setUserData([]);

              void queryClient.invalidateQueries({
                queryKey: [UserKeys.OrgUnitUsers],
              });

              void queryClient.invalidateQueries({
                queryKey: [UserKeys.OrgUnitModels],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="orgUnitsGridStates"
            module={ModuleList.modules.directory.name}
            section={ModuleList.modules.directory.sections.organizationalUnits}
          />
        </>
      }
    ></SharedToolbar>
  );
}
